import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAttendanceTrackingAccess } from 'contexts/AttendanceTrackingAccessContext';

interface AttendanceAdminRequiredProps {
  children: React.ReactNode;
}

export const AttendanceAdminRequired = ({
  children
}: AttendanceAdminRequiredProps) => {
  const { isAdmin } = useAttendanceTrackingAccess();

  if (!isAdmin) {
    return <Navigate to="/attendance-tracking/upload" replace />;
  }

  return <>{children}</>;
};
